import * as React from "react";
const Check = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={14} height={14} rx={7} stroke="#4B5155" />
    <path
      d="M4.5 7.23384L6.67733 9.41128L10.5 5.58875"
      stroke="#4B5155"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default Check;
